<template>
  <div>
    <div v-if="isExistSearchResult">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">棚卸識別名</th>
            <th scope="col">アップロード日</th>
            <th scope="col">アップロードユーザ</th>
            <th scope="col">アップロード状態</th>
            <th scope="col">エラー詳細</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="value in inventoryTargetFileList" :key="value.inventoryCode">
            <td class="table-cell-wrap mw300 mxw300">{{ value.inventoryName }}</td>
            <td class="table-cell-wrap mw300 mxw300">{{ value.createDateTime | moment('YYYY-MM-DD') }}</td>
            <td class="table-cell-wrap mw300 mxw300">{{ value.updateUserName }}</td>
            <td class="table-cell-wrap mw200 mxw200">{{ getUploadStatus(value.uploadStatus) }}</td>
            <td class="table-cell-wrap mw200 mxw200">
              <button type="button" class="errorDetail" v-show="displayErrorDetail(value.uploadStatus)" data-dismiss="modal" aria-label="detail">
                <span v-on:click="openErrorDetail(value.fileId)">詳細</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <InventoryTargetFileErrorDetail :showErrorModal="showErrorModal" :inventoryFileErrorList="inventoryFileErrorList" @closeModal="closeModal"/>
    </div>
    <div v-else>
      検索結果は0件です。
    </div>
  </div>
</template>

<script>
import InventoryTargetFileErrorDetail from '@/components/pages/InvetoryTargetFileErrorDetail'
export default {
  name: 'inventory-target-file-search-result',
  showErrorModal: Boolean,
  props: {
    inventoryTargetFileList: {
      type: Array,
      default: null
    },
    isExistSearchResult: false
  },
  data () {
    return {
      inventoryFileErrorList: [],
      showErrorModal: false
    }
  },
  methods: {
    getUploadStatus (uploadStatus) {
      switch (uploadStatus) {
        case 0:
          return '取込待ち'
        case 1:
          return '取込完了'
        case 2:
          return '取込失敗'
        default:
          return ''
      }
    },
    displayErrorDetail (uploadStatus) {
      return uploadStatus === 2
    },
    async openErrorDetail (fileId) {
      var params = {
        fileId: fileId
      }
      await this.axios.get('/api/inventory/file/error', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        if (response.data.resultList === null || response.data.resultList.length === 0) {
          alert('エラー詳細情報を取得できませんでした')
          this.$emit('setMessage', 'エラー詳細情報を取得できませんでした', false)
        } else {
          this.inventoryFileErrorList = response.data.resultList
          this.showErrorModal = true
        }
      })
    },
    closeModal () {
      this.showErrorModal = false
    }
  },
  computed: {
    getModalFlg () {
      return this.showErrorModal
    }
  },
  components: {
    InventoryTargetFileErrorDetail
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/InventoryTargetFileSearchResult.vue